import React from "react";
import { Box, Container, Typography, Grid } from "@mui/material";

const StatisticsSection = () => {
  const statistics = [
    {
      number: "5000+",
      description: "Healthy Meal Plans Created"
    },
    {
      number: "2000+",
      description: "Active Users on the Platform"
    },
    {
      number: "150+",
      description: "Nutrition Experts & Diet Coaches"
    }
  ];

  return (
    <Container maxWidth="xl" sx={{pb:4, position: "relative", zIndex: 2 }}>
      <Box
        sx={{
          backgroundColor: "#242424",
          borderRadius: "40px",
          padding: { xs: "40px 24px", md: "60px 40px", lg: "40px 60px" },
          maxWidth: "1200px",
          margin: "0 auto",
        }}
      >
        <Grid container spacing={4}>
          {statistics.map((stat, index) => (
            <Grid item xs={12} md={4} key={index}>
              <Box sx={{ textAlign: "center" }}>
                <Typography
                  sx={{
                    fontSize: { xs: "2.5rem", md: "3rem", lg: "3.5rem" },
                    fontWeight: 700,
                    fontFamily: "Outfit",
                    color: "#FFFFFF",
                    mb: 2,
                    lineHeight: 1.1,
                  }}
                >
                  {stat.number}
                </Typography>
                <Typography
                  sx={{
                    fontSize: { xs: "1rem", md: "1.1rem" },
                    fontWeight: 400,
                    fontFamily: "Outfit",
                    color: "rgba(255, 255, 255, 0.8)",
                    lineHeight: 1.5,
                  }}
                >
                  {stat.description}
                </Typography>
              </Box>
            </Grid>
          ))}
        </Grid>
      </Box>
    </Container>
  );
};

export default StatisticsSection;
